import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record3Api = {

    //關鍵字查詢代理申请
    "queryAgentRecord3ByKeyword": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record3/queryAgentRecord3ByKeyword`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                //代理商id
                addinfo2: null,
                //申請狀態 0 申請中，-1 通過，1 下架，2 取消代理
                updatedid: null,
                keyword: null,
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //關鍵字查詢代理申请
    "cancelAgentRecord3": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record3/cancelAgentRecord3`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id:null
            }
        }
    },
    //關鍵字查詢代理申请
    "delAgentRecord3": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record3/delAgentRecord3`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id:null
            }
        }
    },
    //關鍵字查詢代理申请
    "deleteAgentRecord3AndProduct": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record3/deleteAgentRecord3AndProduct`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id:null
            }
        }
    },
}

export default record3Api